import { MainArea, Page, TopArea } from '@salecycle/ui-component-library';
import AppTopBar from 'core/ui/components/AppTopBar/AppTopBar';
import { useFeatureFlags } from 'core/app/AppContext';
import { NotFoundPage } from 'core/ui/components/error';
import { NewRoleProvider } from '../context/NewRoleProvider';
import { NewRoleWizard } from './NewRoleWizard';

export function NewRoleWizardPage() {
  const { flagEnabled } = useFeatureFlags();

  if (flagEnabled('role-management-ui')) {
    return (
      <NewRoleProvider>
        <MainArea>
          <TopArea>
            <AppTopBar />
          </TopArea>

          <Page padding={0}>
            <NewRoleWizard />
          </Page>
        </MainArea>
      </NewRoleProvider>
    );
  } else {
    return <NotFoundPage />;
  }
}
